module.exports = __webpack_public_path__ + "media/images/map/car3-ae68c177511d24243c96f3ec58cd7467.png";